import { useSelector } from "react-redux";
import {
  WorkspaceItem,
  WorkspaceSubscription,
} from "src/types/experiences/workspaces";

interface ExperiencesWorkspaceState {
  experiences: {
    workspaces: {
      workspace: {
        item: WorkspaceItem | null;
      };
    };
  };
}

/**
 * Reads the active workspace's subscription feature flags from Redux.
 * Reusable anywhere flags need to be honoured (create flow, listing, etc.).
 */
export const useWorkspaceSubscription = (): WorkspaceSubscription | null =>
  useSelector(
    (state: ExperiencesWorkspaceState) =>
      state.experiences.workspaces.workspace.item?.subscription ?? null,
  );
